import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: 0,
  utilityId: 1,
  applicationTypeId: 1,
  consumerNumber: "",
  consumerName: "",
  tariffName: "",
  applicant: {
    id: 0,
    applicantTypeId: "",
    applicantName: "",
    panNumber: "",
    gstNumber: "",
    occupancyTypeId: "",
    addressType: "",
    correspondenceAddress: "",
    city: "",
    pinCode: "",
    email: "",
    mobileNumber: "",
    landLine: "",
    alternateEmail: "",
    alternateMobileNumber: "",
    eBillConfirmation: false,
  },
  authorizedPerson: {
    isAuthorizedPerson: "",
    id: 0,
    salutation: "",
    firstName: "",
    middleName: "",
    lastName: "",
    // gender: "",
    // ageCategory: "",
    designation: "",
    email: "",
    mobileNumber: "",
    landLine: "",
  },
  connectionLoad: {
    id: 0,
    backupRequired: "",
    backupkVA: "",
    powerRequirementUnit: "",
    loadDetails: "",
    supplyVoltage: "",
    supplyVoltageUnit: "",
    powerRequirement: "",
    timeShift: "",
    tention: "",
    isGreenPowerRequired: "",
    greenPower: "",
    totalPowerRequirement: "",
    increaseOfLoad: "",
    decreaseOfLoad: "",
  },
  utilityAddress: {
    id: 0,
    premiseTypeId: "",
    premiseUsagePurpose: "",
    premisesAreaId: "",
    zoneId: "",
    blockId: "",
    roadId: "",
    buildingId: "",
    floors: [],
    unitName: "",
    nearestLandmark: "",
    isBPL: "",
    // isRural: "",
    otherZone: "",
    otherBlock: "",
    otherBuilding: "",
    otherRoad: "",
  },
  declaration: {
    declarationId: 0,
    consumerDuesOutstanding: "",
    premisesDuesOutstanding: "",
    firmDuesOutstanding: "",
  },
  documents: [],
  extraValues: {
    premiseTypeId: "",
  },
};

const demandAlterationSlice = createSlice({
  name: "demandAlterationFormData",
  initialState,
  reducers: {
    setValues(_, action) {
      return action.payload;
    },
    resetValues() {
      return initialState;
    },
  },
});

export const { setValues, resetValues } = demandAlterationSlice.actions;

export default demandAlterationSlice.reducer;
